import type { ReactNode, Dispatch, SetStateAction } from "react"
import React, { createContext, useState, useContext } from "react"

import type { VariantTypeV2 } from "types"
import { addBasketItems } from "lib/api"

type ATBConfirmationContextType = {
  showProductAddedBanner: boolean
  handleAddToBag: (
    variant: VariantTypeV2,
    shouldAddFreeTrial: boolean,
    locationType?: string
  ) => Promise<void>
  isATBLoading: boolean
  setIsATBLoading: Dispatch<SetStateAction<boolean>>
}

export const ATBConfirmationContext = createContext(
  {} as ATBConfirmationContextType
)

export const ATBConfirmationProvider: React.FC<{
  children: ReactNode
}> = ({ children }) => {
  const [isATBLoading, setIsATBLoading] = useState(false)
  const [showProductAddedBanner, setShowProductAddedBanner] = useState(false)

  const handleAddToBag = async (
    variant: VariantTypeV2,
    _shouldAddFreeTrial: boolean,
    locationType?: string
  ) => {
    try {
      setIsATBLoading(true)

      await addBasketItems(
        [
          {
            variantId: variant.id,
            quantity: 1,
            type: "product",
            origin: "user",
            variantSku: variant.sku,
          },
        ],
        locationType,
        `${locationType}_CROSSSELL_CAROUSEL`
      )
      setShowProductAddedBanner(true)
      setTimeout(() => {
        setShowProductAddedBanner(false)
      }, 3000)
    } catch (err) {
      console.error(err)
    } finally {
      setIsATBLoading(false)
    }
  }
  return (
    <ATBConfirmationContext.Provider
      value={{
        handleAddToBag,
        setIsATBLoading,
        isATBLoading,
        showProductAddedBanner,
      }}
    >
      {children}
    </ATBConfirmationContext.Provider>
  )
}

export const useATBConfirmationContext = (): ATBConfirmationContextType =>
  useContext(ATBConfirmationContext)
